import { get_headers } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import view_job_profile_logic_mixin from './view_job_profile_logic_mixin';

export default {
  name: 'ViewJobProfile',
  props: {
    jobId: { type: [String, Number], required: true },
    initialMode: { type: String, default: 'view' },
    embeddedEditModal: { type: Boolean, default: false },
    drawerMode: { type: Boolean, default: false },
    drawerExpanded: { type: Boolean, default: false },
    profileMeta: { type: Object, default: () => ({}) },
  },
  emits: [
    'edit-profile',
    'new-advert',
    'manage-advert',
    'view-applicants',
    'view-all-applicants',
    'profile-saved',
    'cancel-edit',
    'close-drawer',
    'toggle-drawer-expand',
  ],
  mixins: [alert_mixin, view_job_profile_logic_mixin],
  data: () => ({
    headers: get_headers(),
    mode: 'view',
    loading: true,
    drawer_active_tab: 'overview',
    form_detail: {
      id: null,
      title: '',
      description: '',
      sections: [],
    },
    source_file_name: '',
    source_file_url: '',
    replacement_job_profile_file: null,
    sections: [],
    _editorInstances: {},
    save_state: 'idle',
    save_message: '',
    save_timer: null,
  }),
  watch: {
    jobId: {
      handler(newVal) {
        if (newVal) {
          this.load_job_profile();
        }
      },
      immediate: true,
    },
    initialMode: {
      handler(newValue) {
        if (newValue === 'edit' || newValue === 'view') {
          this.mode = newValue;
        }
      },
      immediate: true,
    },
  },
};
